module.exports = __webpack_public_path__ + "img/hr-wooden-particle-24.0c348a1f.png";